import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { createTheme, ThemeProvider } from '@mui/material';

import { AuthProvider } from './components/authentication/Auth';
import PrivateRoute from './components/authentication/PrivateRoute';

import SignUp from './screens/SignUp';
import Login from './screens/Login';
import Home from './screens/Home';

import CreateProject from './screens/CreateProject';
import Project from './screens/Project';
import ModifyProject from './screens/ModifyProject';

import CreateSplit from './screens/CreateSplit';
import Split from './screens/Split';
import ModifySplit from './screens/ModifySplit';

import Setting from './screens/Setting';

import NotFound from './screens/NotFound';

const theme = createTheme({
  palette: {
    primary: {
      main: '#000000',
    },
    secondary: {
      main: '#ffffff',
    },
  },
});

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ThemeProvider theme={theme} >
          <Routes>

            {/* PUBLIC ROUTES */}
            <Route path='/signup' element={<SignUp />} />
            <Route path='/login' element={<Login />} />

            {/* PRIVATE ROUTES */}
            <Route path='/' element={
              <PrivateRoute>
                <Home />
              </PrivateRoute>}
            />

            <Route path='/createProject' element={
              <PrivateRoute>
                <CreateProject />
              </PrivateRoute>}
            />

            <Route path='/project/:projectId' element={
              <PrivateRoute>
                <Project />
              </PrivateRoute>}
            />

            <Route path='/modifyProject/:projectId' element={
              <PrivateRoute>
                <ModifyProject />
              </PrivateRoute>}
            />

            <Route path='/createSplit/:projectId' element={
              <PrivateRoute>
                <CreateSplit />
              </PrivateRoute>}
            />

            <Route path='/split/:projectId/:splitId' element={
              <PrivateRoute>
                <Split />
              </PrivateRoute>}
            />

            <Route path='/modifySplit/:projectId/:splitId' element={
              <PrivateRoute>
                <ModifySplit />
              </PrivateRoute>}
            />

            <Route path='/setting' element={
              <PrivateRoute>
                <Setting />
              </PrivateRoute>}
            />

            <Route path='*' element={<NotFound />} />

          </Routes>
        </ThemeProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
